import { waypointInit } from 'helpers/utils';

const waypointConfig = {
    selector: '.pillars',
    funcs: [
        { target: 'waypoint--left' },
        { target: 'waypoint--center' },
        { target: 'waypoint--right' },
    ],
    offset: '80%',
};

function init() {
    waypointInit(waypointConfig);
}

export default init;



// WEBPACK FOOTER //
// ./app/js/modules/pillars.js